import { call, put, takeEvery } from "redux-saga/effects";
import { actions as notificationActions } from "reducers/notification";

import { types, actions } from "reducers/widgets";
import * as widgets from "middleware/widgets";

const sagas = [takeEvery(types.LIST_REQUEST, listRequest)];

export default sagas;

function* listRequest({ widget }) {
    try {
        const response = yield call(widgets.listRequest, widget);

        if (response.type === "W" || response.type === "E") {
            yield put(actions.listFailure(widget, []));
            yield put(notificationActions.showNotification(response.data.message, "error", ["desktop"]));
        } else {
            yield put(actions.listSuccess(widget, response.data.data));
        }
    } catch (e) {
        yield put(actions.listFailure(widget, []));
        yield put(notificationActions.showNotification(e.data.message, "error", ["desktop"]));
    }
}
